import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=34945446&scoped=true&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=34945446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34945446",
  null
  
)

export default component.exports